<template>
    <div class="flex justify-between mt-4 mb-4">
        <button @click="changePage(-1)" :disabled="currentPage === 1"
            class="px-4 py-2 mx-1 bg-gray-300 text-slate-700 hover:text-gray-800 rounded hover:bg-gray-400 disabled:opacity-50">
            Prev
        </button>
        <span>{{ currentPage }} of {{ totalPages }} pages</span>
        <button @click="changePage(+1)" :disabled="currentPage >= totalPages"
            class="px-4 py-2 mx-1 bg-gray-300 text-slate-700 hover:text-gray-800 rounded hover:bg-gray-400 disabled:opacity-50">
            Next
        </button>
    </div>
</template>

<script>
export default {
    name: 'PaginationComponent',
    props: {
        currentPage: { type: Number, required: true },
        totalPages: { type: Number, required: true }
    },
    emits: ["page-change"],
    methods: {
        changePage(amount) {
            this.$emit("page-change", parseInt(this.currentPage) + amount);
        }
    }
}
</script>